import { useEffect, useState } from 'react';

function useElementVisibility(elementId: string, threshold = 0) {
  const [isElementVisible, setIsElementVisible] = useState(false);

  useEffect(() => {
    const watchedElement = document.getElementById(elementId);
    if (!watchedElement) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setIsElementVisible(entry.isIntersecting);
      },
      { threshold }
    );

    observer.observe(watchedElement);
    return () => observer.disconnect();
  }, [elementId, threshold]);

  return isElementVisible;
}

export default useElementVisibility;
